module.exports = __webpack_public_path__ + "assets/img/role-40d8181e.png";